const DEFAULT_COMMISSION_PERCENT = 20;

export const getGuestPrepaymentPercent = (
  advancePercent,
  commissionPercent
) => {
  const advance = Number(advancePercent);
  if (!Number.isFinite(advance)) return null;

  const commission = Number(commissionPercent);
  const markup =
    Number.isFinite(commission) && commission >= 0
      ? commission
      : DEFAULT_COMMISSION_PERCENT;

  return Math.min(100, Math.round(advance + markup));
};
